export const appValidation = {
    create: function () {
        if ($('[data-validation]').length) {
            this.init();
        }
    },

    init: function () {
        $('body')
            .on('blur change', '[data-validation]', this.validate)
            .on('keyup input', '[data-validation]', this.validateKeystroke);
    },

    number_format: function (number, decimals = 0, dec_point = '.', thousands_sep = ',') {
        number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
        let n = isNaN(+number) ? 0 : +number;
        let prec = Math.abs(decimals);
		let s = (prec ? this.toFixedFix(n, prec) : Math.round(n).toString()).split('.');
        s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, thousands_sep);
        if ((s[1] || '').length < prec) {
            s[1] = s[1] || '';
            s[1] += new Array(prec - s[1].length + 1).join('0');
        }
        return s.join(dec_point);
    },

    toFixedFix: function (n, prec) {
        const k = Math.pow(10, prec);
        return '' + Math.round(n * k) / k;
    },

    validate: function (e) {
        const item = e.currentTarget;
        const validation = $(item).data("validation");
        let val = $(item).val();
        let error = false;

        if (!validation) return;

		const formContext = $(item).closest('form');

        switch (validation) {
            case 'float':
                val = appValidation.processFloat(val);
                break;
            case 'integer':
                val = appValidation.processInteger(val);
                break;
            case 'plz':
                val = appValidation.processPlz(val);
                break;
            case 'percentage':
                val = appValidation.processPercentage(val);
                error = val === '';
                break;
            case 'date':
            case 'gebdate':
                val = appValidation.processDate(val, validation);
                error = val === '';
                break;
            case 'mail':
                error = !appValidation.validateEmail(val);
                break;
            case 'phone':
                error = appValidation.validatePhone(formContext);
                break;
        }

        appValidation.toggleErrorState(item, error);
        $(item).val(val);
    },

    processFloat: function (val) {
        val = val.replace('.', '').replace(',', '.');
        return !isNaN(parseFloat(val)) ? appValidation.number_format(val, 2, ",", "") : null;
    },

    processInteger: function (val) {
        val = val.replace('.', '').replace(',', '.');
        return !isNaN(parseInt(val)) ? appValidation.number_format(val, 0, ",", "") : null;
    },

    processPlz: function (val) {
        val = val.replace('.', '');
        return !isNaN(parseInt(val)) ? appValidation.number_format(val, 0, "", "") : null;
    },

    processPercentage: function (val) {
        val = val.replace(',', '.');
        val = parseFloat(val);
        if (val < 0 || val > 100) return '';
        return appValidation.number_format(val, 2, ",", "");
    },

    processDate: function (val, validation) {
        const temp = val.split(".");
        if (temp.length != 3 || !temp[2] || parseInt(temp[0]) > 31 || parseInt(temp[1]) > 12 || parseInt(temp[2]) < 1920 || (validation === 'gebdate' && parseInt(temp[2]) > new Date().getFullYear())) {
            return '';
        }
        val = temp[0].padStart(2, '0') + "." + temp[1].padStart(2, '0') + "." + temp[2].padStart(4, '0');
        const dateReg = /^\d{2}([./-])\d{2}\1\d{4}$/;
        return val.match(dateReg) ? val : '';
    },

    validateEmail: function (val) {
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(val).toLowerCase());
    },

	validatePhone: function (formContext) {
		const phoneInput = formContext.find('[data-validation="phone"]').filter('[name="telefon"]');
		const mobileInput = formContext.find('[data-validation="phone"]').filter('[name="mobil"]');
	
		const phoneVal = phoneInput.val();
		const mobileVal = mobileInput.val();
	
		if (phoneVal === '' && mobileVal === '') {
			// Both fields are empty, so we add the 'required' attribute to both
			phoneInput.attr('required', 'required');
			mobileInput.attr('required', 'required');
			return true; // There's an error because both fields are empty
		} else {
			// At least one field is filled, remove 'required' attribute from both
			phoneInput.removeAttr('required');
			mobileInput.removeAttr('required');
			return false; // No error, one of the fields is filled
		}
	},

    toggleErrorState: function (item, error) {
		console.log('error', error);
        const $item = $(item);
        if (error) {
            $item.addClass('is-invalid');
            $item.closest('.form-group').addClass('is-invalid');
        } else {
            $item.removeClass('is-invalid');
            $item.closest('.form-group').removeClass('is-invalid');
        }
    },

    validateKeystroke: function (e) {
        const item = e.currentTarget;
        const validation = $(item).data("validation");

        if (!validation || validation === 'mail') return;

        let value = $(item).val();
        let validChars = appValidation.getValidChars(validation);
        let newVal = value.split('').filter(char => validChars.includes(char)).join('');

        $(item).val(newVal);
    },

    getValidChars: function (validation) {
        const numbers = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
        const chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZäÄöÖüÜß'.split('');

        switch (validation) {
            case 'float':
            case 'percentage':
                return [...numbers, ','];
            case 'date':
            case 'gebdate':
                return [...numbers, '.'];
            case 'alpha':
                return [...chars, '-', '.', ',', ' ', '(', ')'];
            case 'phone':
            case 'integer':
                return numbers;
            default:
                return [];
        }
    }
};
